var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronUp = function SvgChevronUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 0.999969C8.23386 0.999512 8.4603 1.08089 8.64021 1.22997L14.6402 6.22997C14.8444 6.39971 14.9729 6.64362 14.9972 6.90804C15.0216 7.17247 14.94 7.43575 14.7702 7.63997C14.6005 7.84419 14.3566 7.97261 14.0921 7.99699C13.8277 8.02137 13.5644 7.93971 13.3602 7.76997L8.00021 3.28997L2.64021 7.60997C2.53792 7.69303 2.42023 7.75507 2.29389 7.7925C2.16755 7.82993 2.03506 7.84202 1.90403 7.82808C1.773 7.81414 1.64602 7.77445 1.53038 7.71127C1.41475 7.6481 1.31273 7.5627 1.23021 7.45997C1.13863 7.35715 1.06927 7.23652 1.02648 7.10565C0.983688 6.97477 0.968386 6.83647 0.981528 6.69941C0.994671 6.56235 1.03598 6.42947 1.10286 6.30912C1.16974 6.18876 1.26076 6.08351 1.37021 5.99997L7.37021 1.16997C7.5553 1.04445 7.77711 0.984598 8.00021 0.999969Z",
    fill: "#3F4857"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron_up.7c11a8ed.svg";
export { ForwardRef as ReactComponent };